import React, { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useCollect, useRequest } from 'hooks';

import { WEBINAR_STATES, WEBINAR_TYPES } from 'utils/Constants';

import { Title } from 'components/Misc/Typography';
import { Form, Input, Datepicker, Select, Button } from 'components/Misc/Form';

import { useWebinarCreateStore } from 'store/webinar/useWebinarCreateStore';

const Create = () => {
	// Use router's history
	const history = useHistory();

	// Use webinar's creation store
	const [webinar, onChange, onReset] = useWebinarCreateStore(state => [
		state.webinar,
		state.onChange,
		state.onReset
	]);

	// Store request parameters
	const parameters = useMemo(() => ({
		subjectId: webinar.subjectId
	}), [webinar.subjectId]);

	// Store collected subjects
	const [[subjects], collectSubjects] = useCollect('subjects');

	// Store collected courses
	const [[courses], collectCourses] = useCollect('courses', parameters);

	// Store request
	const [[progress], request] = useRequest('post', 'webinars');

	// Collect subjects on mount
	useEffect(() => {
		(async () => await collectSubjects())();
	}, [collectSubjects]);

	// Collect courses on subject selection
	useEffect(() => {
		if (parameters.subjectId) (async () => await collectCourses())();
	}, [parameters, collectCourses]);

	// Handle store cleanup
	useEffect(() => {
		return () => onReset();
	}, []);

	// Handle submit event
	const onSubmit = async (event) => {
		event.preventDefault();

		// TODO: Remove after test
		console.log(webinar);

		// Try to create webinar
		const [success, error] = await request(webinar);

		// Redirect on successful creation
		if (success) return history.push('/webinars');

		// TODO: Handle errors
		if (error) console.log(error);
	};

	return (
		<Form
			onSubmit={onSubmit}
			className="mx-auto p-4 max-w-screen-md grid md:grid-cols-2 gap-4 bg-white dark:bg-neutral-800 rounded-lg transition-colors"
		>
			<Title
				title="Pamatinformācija"
				className="md:col-span-2 text-xl"
			/>

			<Input
				type="text"
				name="title"
				label="Nosaukums"
				value={webinar.title}
				onChange={onChange}
			/>

			<Datepicker
				time
				asInput
				name="eventAt"
				label="Datums un laiks"
				value={webinar.eventAt}
				onChange={onChange}
			/>

			<Select
				name="subjectId"
				label="Mācību kurss"
				placeholder=" "
				value={webinar.subjectId}
				onChange={onChange}
				options={subjects?.map(subject => ({
					value: subject.id,
					name: subject.title
				}))}
			/>

			<Select
				name="courseId"
				label="Mācību modulis"
				placeholder=" "
				disabled={!courses?.length}
				value={webinar.courseId}
				onChange={onChange}
				options={courses?.map(course => ({
					value: course.id,
					name: course.title
				}))}
			/>

			<Select
				name="type"
				label="Tips"
				placeholder=" "
				value={webinar.type}
				onChange={onChange}
				options={WEBINAR_TYPES?.map(type => ({
					value: type.value,
					name: type.text
				}))}
			/>

			<Select
				name="status"
				label="Statuss"
				placeholder=" "
				value={webinar.status}
				onChange={onChange}
				options={WEBINAR_STATES?.map(state => ({
					value: state.value,
					name: state.text
				}))}
			/>

			<Input
				type="text"
				name="url"
				label="Saite"
				value={webinar.url}
				onChange={onChange}
			/>

			<div className="md:col-span-2 flex justify-end">
				<Button
					submit
					icon="done"
					value="Izveidot"
					theme="success"
					progress={progress}
				/>
			</div>
		</Form>
	);
};

export default Create;